import { NoonReportDateTimeBM } from '../types/BusinessModel/NoonReportDateTimeBM';
import { NoonReportDateTime } from '../types/ViewModel/NoonReportDateTime';
import { convertToDate } from 'odfjell-date-time-utils/dateTimeConverter';

export class NoonReportDateTimeFactory {
    public create(data: NoonReportDateTimeBM): NoonReportDateTime {
        return new NoonReportDateTime(
            data.dateLineCrossed,
            data.aolDateLocalTime,
            convertToDate(data.reportFromTimeLocalTime),
            convertToDate(data.reportToTimeLocalTime),
            convertToDate(data.reportFromTimeUTC),
            convertToDate(data.reportToTimeUTC)
        );
    }

    public createBM(data: any): NoonReportDateTimeBM {
        return {
            aolDateLocalTime: data.aolDateLocalTime,
            dateLineCrossed: data.dateLineCrossed,
            reportFromTimeLocalTime: data.reportFromTimeLocalTime,
            reportToTimeLocalTime: data.reportToTimeLocalTime,
            reportFromTimeUTC: data.reportFromTimeUTC,
            reportToTimeUTC: data.reportToTimeUTC,
        };
    }
}
